/** @format */
import { _$ } from '@king-design/react'

// 触发规则key
export const TriggerRuleKeyEnum = {
  region_key: _$('机房'),
  namespaceid: _$('产品类型'),
  host: _$('实例ID'),
  host_name: _$('实例名称'),
  event_type: _$('事件类型'),
  event_name: _$('事件名称'),
  event_level: _$('事件等级'),
  event_status: _$('事件状态'),
  content: _$('事件内容'),
  xid: 'xid'
}

export const TriggerRuleKeyAggEnum = {
  key: _$('聚合Key'),
  length: _$('聚合长度')
}
// 输入内容的规则key
export const RuleKeyInput = ['host', 'host_name', 'xid', 'content']

// 触发规则operator
export const TriggerRuleOperatorOpts = ['==', '!=', '=~', '!~', 'in']

// 根据Key获取操作符
export const getTriggerRuleOperator = (
  Key: keyof typeof TriggerRuleKeyEnum | keyof typeof TriggerRuleKeyAggEnum | ''
) => {
  if (Key === 'namespaceid') {
    return ['==']
  } else if (Key === 'length') {
    return ['==', '!=', '>', '>=', '<', '<=']
  } else if (RuleKeyInput.includes(Key)) {
    return TriggerRuleOperatorOpts
  } else {
    return ['in']
  }
}

// 支持搜索历史事件的字段
export const SearchHistoryEventFields = {
  region_key: 'SearchRegion',
  namespaceid: 'Namespace',
  event_type: 'EventType',
  event_name: 'Name',
  event_level: 'Level',
  event_status: 'Status',
  content: 'SearchKeywords',
  host: 'Uuid',
  host_name: 'InstanceName'
}
export const SearchHistoryEventFieldsOps = {
  '==': 'equals',
  '!=': 'not_equals',
  '=~': 'regex',
  '!~': 'not_regex',
  in: 'in'
}
